module.exports = __webpack_public_path__ + "static/media/footerIos.ff936e47.svg";